'use client';

import { AccountUsername as Section } from '../../components/UserProfile/AccountSections';
import { createSection } from '../createSection';

export const UserProfileUsernameSection = createSection('UserProfileUsernameSection', Section);
